import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { ExpensesFormValuesProps } from "../../ExpenseModal.types";

import styles from "../../ExpenseModal.module.scss";

const MainInformation = () => {
  const { t } = useTranslation();

  const { register, formState } = useFormContext<ExpensesFormValuesProps>();
  const { errors } = formState;

  return (
    <>
      <div className={styles["modal__content--block"]}>
        <Input
          label="Title"
          placeholder={t("Enter title")}
          errorMessage={errors.title?.message}
          {...register("title")}
        />
        <div className={styles["modal__content--block-last"]}>
          <Input
            label="Amount (FCFA)"
            placeholder={t("Enter amount")}
            type="number"
            errorMessage={errors.amount?.message}
            {...register("amount")}
          />
        </div>
      </div>

      <div className={styles["modal__content--block"]}>
        <Input
          label="Type"
          placeholder={t("Enter type")}
          errorMessage={errors.type?.message}
          {...register("type")}
        />
        <div className={styles["modal__content--block-last"]}>
          <Input
            label="Quantity"
            placeholder={t("Enter quantity")}
            type="number"
            errorMessage={errors.quantity?.message}
            {...register("quantity")}
          />
        </div>
      </div>

      <Input
        asTag="textarea"
        label="Description"
        placeholder={t("Enter description")}
        {...register("description")}
        errorMessage={errors.description?.message}
      />
    </>
  );
};

export default MainInformation;
